module.exports = __webpack_public_path__ + "static/media/waitlist.a6aa795b.svg";